import { render, staticRenderFns } from "./AddStoneImage.vue?vue&type=template&id=f5b2b7ae&"
import script from "./AddStoneImage.vue?vue&type=script&lang=js&"
export * from "./AddStoneImage.vue?vue&type=script&lang=js&"
import style0 from "./AddStoneImage.vue?vue&type=style&index=0&id=f5b2b7ae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports